export const optionsHeights: string[] = Array.from({ length: 61 }, (_, i) =>
  (150 + i).toString(),
);
